/*
 * Authors: mariushirjanu
 * Created: 18/02/2019
 */
import * as _ from 'underscore';
import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { CompanyDataService, CompanyType, ICodeDescription } from '../../../shared/company/company-data.service';
import { FormattingService } from '../../../shared/services/formatting.service';
import { IWebshopData, IWebshopRequest, WebshopService } from '../webshop.service';
import { WebshopDataService } from '../webshop-data.service';
import { GA1MenuService } from '../../../shared/ga1/ga1-menu.service';
import { ICompany, ICompanyCountry, ICompanyExtended, IContact, ICountryExtended, IGenericUser, INamedObject, IObject, IValueObject, IWebshop } from '../../../../type_definitions/datatypes';
import { IUserData } from '../../../shared/services/auth/auth-data.service';
import { TranslationService } from '../../../shared/translation/translation.service';
import { GaFormlyService, IExtraFieldConfigurationObject, IFieldOption } from '../../../shared/formly/ga-formly.service';
import { DialogSize, GaMessageService, IDialog } from '../../../shared/message/ga-message.service';
import { GaValidateService } from '../../../shared/formly/ga-validate.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { util } from '../../../shared/util';
import { UserProfileWrapperComponent } from '../../userprofile/user-profile-wrapper.component';
import { CompanyDialogComponent } from '../../company/company-dialog.component';
import { STATE_WEBSHOPINFO } from '../../../shared/app-states';
import { StateService } from '@uirouter/angular';
import { GaWizard } from '../../../shared/wizard/ga-wizard';
import { GaWizardService } from '../../../shared/wizard/ga-wizard.service';
import { WIZARD_WEBSHOP } from '../../../shared/app-wizards';

interface IWebshopSetupFormFields {
  webshopFields:IExtraFieldConfigurationObject[];
  forecastFields:IExtraFieldConfigurationObject[];
  catalogFields:IExtraFieldConfigurationObject[];
  usersFields:IExtraFieldConfigurationObject[];
  lamFields:IExtraFieldConfigurationObject[];
  oemFields:IExtraFieldConfigurationObject[];
  acslFields:IExtraFieldConfigurationObject[];
}

const SAVE_ACTION:string = 'save';
const LAM_MAIN_CONTACTS:string = 'lamMainContacts';
const OEM_MAIN_CONTACTS:string = 'oemMainContacts';

@Component({
  selector: 'webshop-setup',
  template: `
    <div *ngIf="fields" class="webshop-setup row">

      <div class="col-md-12">
        <h4 class="form-title" translate>GA.GENERAL.WEBSHOP</h4>
        <div class="col-space-bottom">
          <formly [form]="form" [fields]="fields.webshopFields" [model]="model" [noValidate]="true" class="form-horizontal"></formly>
        </div>
      </div>


      <div class="col-md-6">

        <h4 class="form-title" translate>WEBSHOP.HEADINGS.FORECAST</h4>
        <formly [form]="form" [fields]="fields.forecastFields" [model]="model" [noValidate]="true" class="form-horizontal"></formly>

        <h4 class="form-title" translate>WEBSHOP.HEADINGS.CATALOG</h4>
        <formly [form]="form" [fields]="fields.catalogFields" [model]="model" [noValidate]="true" class="form-horizontal"></formly>

        <h4 class="form-title" translate>WEBSHOP.HEADINGS.USERS</h4>
        <formly [form]="form" [fields]="fields.usersFields" [model]="model" [noValidate]="true" class="form-horizontal"></formly>
      </div>


      <div class="col-md-5 offset-md-1">
        <h4 class="form-title">LAM</h4>
        <formly [form]="form" [fields]="fields.lamFields" [model]="model" [noValidate]="true" class="form-horizontal"></formly>

        <h4 class="form-title">
          <span translate>WEBSHOP.HEADINGS.MAIN_OEM</span>&nbsp;
          <label class="switch">
            <input type="checkbox" [(ngModel)]="model.isMainOEM" (change)="onMainOEMSliderChange()">
            <span class="slider"></span>
          </label>
        </h4>
        <formly [form]="form" [fields]="fields.oemFields" [model]="model" [noValidate]="true" class="form-horizontal"></formly>

        <h4 class="form-title">ACSL</h4>
        <formly [form]="form" [fields]="fields.acslFields" [model]="model" [noValidate]="true" class="form-horizontal"></formly>
      </div>
    </div>
  `,
  styleUrls: [ './webshop-setup.scss' ],
  encapsulation: ViewEncapsulation.None
})
export class WebshopSetupComponent implements OnInit, OnDestroy {
  public model:IWebshopData;
  public form:UntypedFormGroup = new UntypedFormGroup({});
  public fields:IWebshopSetupFormFields;
  private currentUser:IUserData;
  private isLoggedUserGBDM:boolean;
  private customerField:IExtraFieldConfigurationObject;
  private customerMinLength:number = 2;
  private addCustomerButtonField:IExtraFieldConfigurationObject;
  private catalogUploadDateField:IExtraFieldConfigurationObject;
  private userListUploadDateField:IExtraFieldConfigurationObject;
  private lamTypeField:IExtraFieldConfigurationObject;
  private lamCompanyCountryField:IExtraFieldConfigurationObject;
  private lamCompanyDepartmentField:IExtraFieldConfigurationObject;
  private lamCustomerCountryField:IExtraFieldConfigurationObject;
  private lamMainContactsField:IExtraFieldConfigurationObject;
  private oemField:IExtraFieldConfigurationObject;
  private oemMainContactsField:IExtraFieldConfigurationObject;
  private oemCustomerIdField:IExtraFieldConfigurationObject;
  private oemCustomerTypeField:IExtraFieldConfigurationObject;
  private gbdmField:IExtraFieldConfigurationObject;
  private webshopNameField:IExtraFieldConfigurationObject;
  private wizard:GaWizard;

  constructor(
    private authService:AuthService,
    private companyDataService:CompanyDataService,
    private formattingService:FormattingService,
    private formlyService:GaFormlyService,
    private messageService:GaMessageService,
    private validateService:GaValidateService,
    private wizardService:GaWizardService,
    private webshopService:WebshopService,
    private webshopDataService:WebshopDataService,
    private ga1MenuService:GA1MenuService,
    private translationService:TranslationService,
    private stateService:StateService
  ) {

  }

  public ngOnInit():void {
    this.wizard = this.wizardService.getInstance(WIZARD_WEBSHOP);
    this.initController();
  }

  private initController = ():void => {
    this.currentUser = this.authService.getCurrentUser();
    this.model = this.webshopService.getWebshopProfile();
    this.fields = this.createFields();
    this.fillFields();
    this.disableOEMMainContactsField();

    this.initWizardSetup();
  };

  private initWizardSetup():void {
    // set the current validator to be able to call validateCurrent() in the parent component
    this.wizard.currentValidator(this.validateForm, true);

    this.wizard.addAction(
      this.wizardService.createActionButton(
        SAVE_ACTION,
        this.translationService.instant('GA.BUTTONS.SAVE_LABEL', { label: this.translationService.instant('GA.GENERAL.WEBSHOP') }),
        'btn btn-success',
        this.saveWebshop,
        !!this.webshopService.getWebshopId()
      )
    );
  }

  private fillFields():void {
    if (!this.authService.checkAcslUser()) {
      // as LAM Type is not shown to non-ACSL users, manually trigger onLAMTypeChange() to populate LAM company countries
      this.onLAMTypeChange();
    }

    const companyGBDMsPromise:Promise<IContact[]> = this.companyDataService.getCompanyGBDMs()
      .then((gbdms:IContact[]) => {
        // try to find the logged in user in the list (acsl user), otherwise check if there is only one user and auto select it (in case of bp/vendor user)
        let selectedGBDM:IContact = _.find(gbdms, (gbdm:IContact) => gbdm.id === this.currentUser.id);

        if (!selectedGBDM && gbdms?.length === 1) {
          selectedGBDM = gbdms[ 0 ];
        }

        this.form.patchValue({ gbdm: selectedGBDM });

        this.isLoggedUserGBDM = !!selectedGBDM;
        return gbdms;
      });
    this.formlyService.fillField(this.gbdmField, companyGBDMsPromise);
  }

  private createFields():IWebshopSetupFormFields {
    const form:IWebshopSetupFormFields = {
      webshopFields: [],
      forecastFields: [],
      catalogFields: [],
      usersFields: [],
      lamFields: [],
      oemFields: [],
      acslFields: []
    };

    const labelClass:IObject = {
      columnMain: 'col-lg-2 col-md-3',
      columnLeft: 'col-lg-5 col-md-6',
      columnRight: 'col-lg-5 col-md-5'
    };

    const valueClass:IObject = {
      columnMain: 'col-md-4',
      columnLeft: 'col-lg-7 col-md-6',
      columnRight: 'col-lg-7 col-md-7',
      columnHalf: 'col-lg-4 col-md-6'
    };

    // ---- WEBSHOP fields ----
    this.customerField = this.formlyService.aSearch('customer', 'GA.GENERAL.CUSTOMER')
      .isRequired()
      .withoutWrapper()
      .withWrapperClass('col-md-6')
      .withFormat(this.formattingService.formatName)
      .withMinLength(this.customerMinLength)
      .withExtraOptions({
        templateOptions: {
          searchFunction: {
            request: (filter:string) => this.companyDataService.searchWebshopCompanies(filter, this.model.limitToCustomer? CompanyType.CUSTOMER : undefined)
          },
          autoClear: false // prevent auto clearing the search value on blur
        },
        validators: {
          customerValidator: {
            expression: (control:UntypedFormControl) => {
              const customer:ICompany | string = control.value;
              return _.isObject(customer);
            },
            message: this.translationService.instant('WEBSHOP.CUSTOMER_VALIDATION_MESSAGE')
          }
        }
      })
      .onChange(this.onCustomerChange)
      .build();

    const limitToCustomerField:IExtraFieldConfigurationObject = this.formlyService.aCheckbox('limitToCustomer', 'WEBSHOP.LIMIT_TO_CUSTOMER')
      .withoutWrapper()
      .withWrapperClass('col-md-5')
      .withHideExpression(() => !this.authService.checkAcslUser())
      .build();

    this.addCustomerButtonField = this.formlyService.aLink('WEBSHOP.ADD_NEW_CUSTOMER')
      .isHide()
      .withoutWrapper()
      .onClick(this.addCompanyDialog)
      .withExtraOptions({
        templateOptions: {
          linkClass: 'btn-primary'
        }
      })
      .withWrapperClass('col-md-12 float-start add-customer')
      .build();


    form.webshopFields.push(
      this.formlyService.aGroup(undefined, 'GA.GENERAL.CUSTOMER')
        .withFields([
          this.customerField,
          limitToCustomerField,
          this.addCustomerButtonField
        ])
        .withLabelClass(labelClass.columnMain)
        .withValueClass('col-lg-8 col-md-9')
        .build(),

      this.webshopNameField = this.formlyService.anInput('webshopName', 'WEBSHOP.WEBSHOP_NAME')
        .isRequired()
        .withLabelClass(labelClass.columnMain)
        .withValueClass(valueClass.columnMain)
        .withLoading(false)
        .withMinLength(4)
        .withExtraOptions({
          asyncValidators: {
            uniqueWebshop: {
              expression: this.checkWebshopDuplicates, // when promise returns true => no webshops found (no error message)
              message: this.translationService.instant('WEBSHOP.WEBSHOP_EXISTS')
            }
          },
          modelOptions: {
            updateOn: 'blur' // update on blur instead of updating at any character typed in
          }
        })
        .build(),

      this.formlyService.anInput('webshopDescription', 'WEBSHOP.WEBSHOP_DESCRIPTION')
        .withLabelClass(labelClass.columnMain)
        .withValueClass(valueClass.columnMain)
        .build()
    );


    // ---- FORECAST fields ----

    form.forecastFields.push(
      this.formlyService.aDateInput('expectedDecisionDate', 'WEBSHOP.EXPECTED_DECISION_DATE')
        .isRequired()
        .withLabelClass(labelClass.columnLeft)
        .withValueClass(valueClass.columnHalf)
        .build(),

      this.formlyService.aDateInput('expectedStartDate', 'WEBSHOP.EXPECTED_START_DATE')
        .withLabelClass(labelClass.columnLeft)
        .withValueClass(valueClass.columnHalf)
        .build(),

      this.formlyService.anInput('expectedOrdersPerYear', 'WEBSHOP.EXPECTED_ORDERS_PER_YEAR')
        .withInputType('number')
        .withMaxLength(9)
        .withPattern(/^\d*$/)
        .withLabelClass(labelClass.columnLeft)
        .withValueClass(valueClass.columnHalf)
        .withExtraOptions({
          templateOptions: {
            min: 0
          }
        })
        .build(),

      this.formlyService.anInput('revenueForecast', 'WEBSHOP.REVENUE_FORECAST')
        .isRequired()
        .withInputType('number')
        .withPattern(/^\d*$/)
        .withMaxLength(9)
        .withLabelClass(labelClass.columnLeft)
        .withValueClass(valueClass.columnHalf)
        .withAddOn('USD')
        .withExtraOptions({
          templateOptions: {
            min: 0
          }
        })
        .build()
    );


    // ---- CATALOG fields ----
    let catalogUploadFieldRequired:boolean = false;

    form.catalogFields.push(
      this.formlyService.aRadio('catalogAvailable', 'WEBSHOP.CATALOG_AVAILABLE')
        .isRequired()
        .withFormat(this.formattingService.formatLov)
        .withWrapperClass('radio-horizontal')
        .withLabelClass(labelClass.columnLeft)
        .withValueClass(valueClass.columnLeft)
        .withOptions(<IValueObject[]>this.formlyService.getBooleanOptions())
        .withInline()
        .onChange(() => {
          catalogUploadFieldRequired = !!this.model.catalogAvailable?.id;
          this.catalogUploadDateField.templateOptions.required = catalogUploadFieldRequired;
        })
        .build(),

      this.catalogUploadDateField = this.formlyService.aDateInput('catalogUploadDate', 'WEBSHOP.EXPECTED_UPLOAD_DATE')
        .withLabelClass(labelClass.columnLeft)
        .withValueClass(valueClass.columnHalf)
        .withRequired(catalogUploadFieldRequired)
        .build(),

      this.formlyService.anInput('catalogComment', 'GA.GENERAL.COMMENT')
        .withLabelClass(labelClass.columnLeft)
        .withValueClass(valueClass.columnLeft)
        .build()
    );


    // ---- USERS fields ----
    let userListUploadDateFieldRequired:boolean = false;

    form.usersFields.push(
      this.formlyService.aRadio('userListAvailable', 'WEBSHOP.USER_LIST_AVAILABLE')
        .withFormat(this.formattingService.formatLov)
        .withWrapperClass('radio-horizontal')
        .withLabelClass(labelClass.columnLeft)
        .withValueClass(valueClass.columnLeft)
        .withOptions(<IValueObject[]>this.formlyService.getBooleanOptions())
        .withInline()
        .onChange(() => {
          userListUploadDateFieldRequired = !!this.model.userListAvailable?.id;
          this.userListUploadDateField.templateOptions.required = userListUploadDateFieldRequired;
        })
        .build(),

      this.userListUploadDateField = this.formlyService.aDateInput('userListUploadDate', 'WEBSHOP.EXPECTED_UPLOAD_DATE')
        .withLabelClass(labelClass.columnLeft)
        .withValueClass(valueClass.columnHalf)
        .withRequired(userListUploadDateFieldRequired)
        .withExtraOptions({})
        .build(),

      this.formlyService.anInput('usersComment', 'GA.GENERAL.COMMENT')
        .withLabelClass(labelClass.columnLeft)
        .withValueClass(valueClass.columnLeft)
        .build()
    );


    // ---- LAM fields ----

    if (this.authService.checkAcslUser()) {
      const lamTypeList:IFieldOption[] = [
        {
          id: CompanyType.BP,
          value: 'BP'
        },
        {
          id: CompanyType.OEM,
          value: 'OEM'
        },
        {
          id: CompanyType.CUSTOMER,
          value: 'GA.GENERAL.CUSTOMER',
          disabled: true
        }
      ];

      form.lamFields.push(
        this.lamTypeField = this.formlyService.aRadio('lamType', 'GA.GENERAL.TYPE')
          .withFormat(this.formattingService.formatLov)
          .withWrapperClass('radio-horizontal')
          .withLabelClass(labelClass.columnRight)
          .withValueClass(valueClass.columnRight)
          .withOptions(lamTypeList)
          .withInline()
          .onChange(this.onLAMTypeChange)
          .build()
      );
    }

    form.lamFields.push(
      this.lamCompanyCountryField = this.formlyService.aSelect('lamCompanyCountry', 'LAM')
        .isRequired()
        .withFormat(this.formattingService.formatCompanyCountryL)
        .withLabelClass(labelClass.columnRight)
        .withValueClass(valueClass.columnRight)
        .withHideExpression(() => this.model.lamType && this.model.lamType.id !== CompanyType.BP)
        .withLoading(false)
        .onChange(() => {
          this.onLAMChange();
        })
        .build(),

      this.lamCompanyDepartmentField = this.formlyService.aSelect('lamCompanyDepartment', 'LAM')
        .isRequired()
        .withFormat(this.formattingService.formatCompanyCountryL)
        .withLabelClass(labelClass.columnRight)
        .withValueClass(valueClass.columnRight)
        .withHideExpression(() => !this.model.lamType || this.model.lamType.id !== CompanyType.OEM)
        .withLoading(false)
        .onChange(() => {
          this.onLAMChange();
        })
        .build(),

      this.lamCustomerCountryField = this.formlyService.aSelect('lamCustomerCountry', 'LAM')
        .isRequired()
        .withFormat(this.formattingService.formatName)
        .withLabelClass(labelClass.columnRight)
        .withValueClass(valueClass.columnRight)
        .withHideExpression(() => !this.model.lamType || this.model.lamType.id !== CompanyType.CUSTOMER)
        .withLoading(false)
        .onChange(() => {
          this.onLAMChange();
        })
        .build(),
      this.lamMainContactsField = this.formlyService.aMultiSelect(LAM_MAIN_CONTACTS, 'WEBSHOP.MAIN_CONTACT')
        .isDisabled()
        .isRequired()
        .withLabelClass(labelClass.columnRight)
        .withValueClass(valueClass.columnRight)
        .withFormat(this.formattingService.formatContact)
        .withExtraOptions({
          templateOptions: {
            searchFunction: {
              request: (filter:string) => {
                return this.webshopService.getLAM()
                  .then((lam:ICompanyCountry) => this.companyDataService.getLAMMainContacts(filter, <string>this.model.lamType.id, lam?.id));
              }
            },
            minSearchLength: 1
          }
        })
        .withOptions(!this.authService.checkAcslUser()? [ this.currentUser ] : [])
        .build(),
      this.formlyService.aValue('superLAM', 'WEBSHOP.SUPER_LAM')
        .withLabelClass(labelClass.columnRight)
        .withValueClass(valueClass.columnRight)
        .withFormat((companyCountry:ICompanyCountry) => companyCountry && `${companyCountry.company?.name} - ${companyCountry.country?.name}`)
        .build()
    );

    if (this.authService.checkAcslUser()) {
      this.lamMainContactsField.templateOptions.addFunction = {
        label: 'WEBSHOP.CREATE_NEW_CONTACT',
        onClick: (searchTerm:string) => this.createNewContactDialog(LAM_MAIN_CONTACTS, searchTerm)
      };
    }

    // ---- MAIN OEM fields ----
    this.oemMainContactsField = this.formlyService.aMultiSelect(OEM_MAIN_CONTACTS, 'WEBSHOP.MAIN_CONTACT_VGAM')
      .withLabelClass(labelClass.columnRight)
      .withValueClass(valueClass.columnRight)
      .withFormat(this.formattingService.formatContact)
      .withExtraOptions({
        templateOptions: {
          searchFunction: {
            request: (filter:string):Promise<IContact[]> => this.companyDataService.getVGAMContacts(filter, this.model.oem?.id)
          },
          minSearchLength: 1,
          addFunction: {
            label: 'WEBSHOP.CREATE_NEW_CONTACT',
            onClick: (searchTerm:string) => this.createNewContactDialog(OEM_MAIN_CONTACTS, searchTerm)
          }
        }
      })
      .withOptions(this.authService.checkVendorUser()? [ this.currentUser ] : [])
      .build();


    this.oemField = this.formlyService.aSearch('oem', 'OEM')
      .isRequired()
      .withLabelClass(labelClass.columnRight)
      .withValueClass(valueClass.columnRight)
      .withFormat(this.formattingService.formatCompany)
      .withExtraOptions({
        templateOptions: {
          searchFunction: {
            request: (name:string) => this.companyDataService.getVendorCompanies(true, name)
          },
          minSearchLength: 1
        }
      })
      .onChange(this.onOEMChange)
      .build();

    if (this.authService.checkPartnerUser()) {
      const companyCountryId:number = this.currentUser?.location?.companyCountry?.id;
      const label:string = companyCountryId? `<a href="/ga2/#/bpprofiles/cc:${companyCountryId}/oem" target="_blank">${this.translationService.instant('GA.GENERAL.BP_PROFILE')}</a>` : this.translationService.instant('GA.GENERAL.BP_PROFILE');
      this.oemField.templateOptions.info = this.translationService.instant('WEBSHOP.OEM_INFO_BP', { label });
      this.oemField.templateOptions.showInfo = true;
    }

    form.oemFields.push(
      this.oemField,

      this.oemMainContactsField,

      this.oemCustomerIdField = this.formlyService.anInput('oemCustomerId', 'WEBSHOP.CUSTOMER_ID_OEM')
        .withLabelClass(labelClass.columnRight)
        .withValueClass(valueClass.columnRight)
        .build(),

      this.oemCustomerTypeField = this.formlyService.aSelect('oemCustomerType', 'WEBSHOP.CUSTOMER_TYPE')
        .isHide()
        .withFormat(this.formattingService.formatDescription)
        .withLabelClass(labelClass.columnRight)
        .withValueClass(valueClass.columnRight)
        .build()
    );


    // ---- ACSL fields ----
    if (this.authService.checkAcslUser()) {
      this.gbdmField = this.formlyService.aSelect('gbdm', 'GBDM')
        .withFormat(this.formattingService.formatContact)
        .withLabelClass(labelClass.columnRight)
        .withValueClass(valueClass.columnRight)
        .build();
    } else {
      this.gbdmField = this.formlyService.aValue('gbdm', 'GBDM')
        .withFormat(this.formattingService.formatContact)
        .withLabelClass(labelClass.columnRight)
        .withValueClass(valueClass.columnRight)
        .build();
    }

    form.acslFields.push(
      this.gbdmField
    );

    return form;
  }

  private onCustomerChange = (customer:ICompany | string):void => {
    const validCustomer:boolean = _.isObject(customer);
    this.addCustomerButtonField.hide = !customer || validCustomer || (!validCustomer && (<string>customer).length < this.customerMinLength);

    const customerId:number = (<ICompany>customer)?.id;

    // when there is a change excluding the keypress event
    const onCustomerRealChange = () => {
      this.form.patchValue({ lamCustomerCountry: undefined });

      if (this.lamTypeField) {
        this.updateLAMCustomerOptionState(customerId);
      }
    };

    if (customerId) {
      this.companyDataService.getCompanyWebshops(customerId)
        .then((webshops:IWebshop[]) => {
          if (!this.webshopNameField.formControl.dirty) {
            this.form.patchValue({ webshopName: !webshops?.length? this.model.customer.name : undefined });
            // make sure that the validation is triggered and it shows up
            this.webshopNameField.formControl.markAsDirty();
          }
        });
      onCustomerRealChange();
    } else if (util.isNullOrUndefinedOrEmpty(this.model.customer)) {
      // when no selection from list or the selected customer is removed
      this.model.webshopName = undefined;
      this.lamMainContactsField.templateOptions.disabled = true;
      onCustomerRealChange();
    }
  };

  public onMainOEMSliderChange():void {
    this.form.patchValue({
      oem: undefined,
      oemMainContacts: undefined,
      oemCustomerId: undefined,
      oemCustomerType: undefined
    });

    this.oemField.templateOptions.required = this.model.isMainOEM;
    this.oemField.templateOptions.disabled = !this.model.isMainOEM;
    this.oemMainContactsField.templateOptions.disabled = !this.model.isMainOEM;
    this.oemCustomerIdField.templateOptions.disabled = !this.model.isMainOEM;
    this.oemCustomerTypeField.templateOptions.disabled = !this.model.isMainOEM;
    this.disableOEMMainContactsField();
  }

  private validateForm = ():Promise<void|string[]> => {
    return this.validateService.validateFields(
      this.fields.webshopFields.concat(
        this.fields.forecastFields,
        this.fields.catalogFields,
        this.fields.usersFields,
        this.fields.lamFields,
        this.fields.oemFields,
        this.fields.acslFields
      ),
      this.model,
      true
    );
  };

  private addCompanyDialog = ():void => {
    // binding: onSaved
    const onSaved = (companyData:ICompanyExtended):void => {
      this.form.patchValue({
        customer: {
          id: companyData.id,
          name: companyData.name,
          companyType: companyData.companyType
        },
        webshopName: companyData?.name
      });

      addCompanyDialog.hide();
    };

    // binding: onCancel
    const onCancel = ():void => {
      addCompanyDialog.hide();
    };

    const addCompanyDialog:IDialog = this.messageService.showDialog({
      component: CompanyDialogComponent,
      wrapperComponent: false,
      inputs: {
        companyId: 'NEW',
        companyName: this.model.customer,
        isInDialog: true
      },
      outputs: {
        onSaved,
        onCancel
      },
      size: DialogSize.LG
    });
  };

  private createNewContactDialog = (key:string, searchTerm:string):void => {
    const getInputs:Function = ():Promise<IObject> => {
      const inputs:IObject = {
        userId: 'NEW',
        firstName: !/\s/.test(searchTerm)? util.capitalize(searchTerm) : undefined
      };

      if (!/\s/.test(searchTerm)) {
        inputs.firstName = util.capitalize(searchTerm);
      }

      if (key === LAM_MAIN_CONTACTS) {
        // when LAM user is created from Webshop creation -> preselect the PARTNER LAM user
        inputs.genericUserFn = (genericUsers:IGenericUser[]) => _.find(genericUsers, (gu:IGenericUser) => gu.externalGroup?.code === 'PARTNER_LAM_USER');
      }

      // the dialog must have companyId & countryId available at the init time
      return new Promise((resolve, reject) => {
        if (key === OEM_MAIN_CONTACTS) {
          // oem company
          inputs.companyId = this.model.oem?.id;
          resolve(inputs);
        } else {
          // lam company
          this.webshopService.getLAM()
            .then((lam:ICompanyCountry) => {
              inputs.companyId = lam?.company?.id;
              inputs.countryId = lam?.country?.id;
              resolve(inputs);
            })
            .catch(reject);
        }
      });
    };

    let userProfileDialog:IDialog;

    // binding: onSaved
    const onSaved = (userData:IUserData):void => {
      const contacts:IUserData[] = this.model[ key ] || [];
      contacts.push(userData);
      this.form.patchValue({ [ key ]: contacts });
      userProfileDialog.hide();
    };

    // binding: onCancel
    const onCancel = ():void => {
      userProfileDialog.hide();
    };

    getInputs()
      .then((inputs:IObject) => {
        userProfileDialog = this.messageService.showDialog({
          component: UserProfileWrapperComponent,
          wrapperComponent: false,
          inputs,
          outputs: {
            onSaved,
            onCancel
          },
          size: DialogSize.XL
        });
      });
  };

  private onOEMChange = (oem:ICompany):void => {
    this.clearOEMMainContactsField();
    this.disableOEMMainContactsField();
    this.form.patchValue({
      oemCustomerType: undefined
    });

    if (oem) {
      this.formlyService.fillField(this.oemCustomerTypeField, this.companyDataService.getOEMCustomerTypes(oem.id))
        .then((customerTypes:ICodeDescription[]) => {
          this.oemCustomerTypeField.hide = !customerTypes.length;
        });
    } else {
      this.oemCustomerTypeField.hide = !oem;
    }
  };

  private saveWebshop = ():void => {
    this.validateForm()
      .then(() => {
        this.webshopService.updateWizardButtonStatus(true);

        this.webshopService.createWebshopProfileRequest()
          .then((requestData:IWebshopRequest) => {
            const saveCompanyFn:Promise<INamedObject> = this.webshopDataService.addWebshop(requestData);

            saveCompanyFn
              .then((webshopData:INamedObject) => {
                this.afterSave(webshopData);
                return webshopData;
              })
              .finally(() => {
                this.webshopService.updateWizardButtonStatus(false);
              });
          });
      });
  };

  private afterSave(webshopData:INamedObject):void {
    this.messageService.showFeedbackAfterSave('GA.GENERAL.WEBSHOP');

    if (this.webshopService.onSaved) {
      this.webshopService.onSaved.emit(webshopData.id);
    }
    if (webshopData?.id && !this.webshopService.isInDialog) {
      // redirect to GA2 Webshop Info screen
      this.stateService.go(STATE_WEBSHOPINFO, {
        webshopId: webshopData.id,
        menu: this.ga1MenuService.getMenuParamValue(webshopData.id)
      });
    }
  }

  private checkWebshopDuplicates = (control:UntypedFormControl):Promise<any> => {
    return this.webshopDataService.searchWebshops(control.value)
      .then((webshops:IWebshop[]) => {
        return !webshops?.length;
      });
  };

  private onLAMTypeChange = ():void => {
    const lamType:string = <string>this.model.lamType?.id;

    this.model.lamCompanyCountry = undefined;
    this.model.lamCompanyDepartment = undefined;
    this.model.lamCustomerCountry = undefined;

    this.clearLAMMainContactsField();
    this.clearOEMMainContactsField();
    if (!this.isLoggedUserGBDM) {
      this.form.patchValue({
        gbdm: undefined
      });
    }

    let fillLAMFieldPromise:Promise<any>;
    switch (lamType) {
      case CompanyType.BP:
        fillLAMFieldPromise = this.formlyService.fillField(this.lamCompanyCountryField, this.lamCompanyCountriesPromise());
        break;
      case CompanyType.OEM:
        fillLAMFieldPromise = this.formlyService.fillField(this.lamCompanyDepartmentField, this.lamCompanyDepartmentsPromise());
        break;
      case CompanyType.CUSTOMER:
        fillLAMFieldPromise = this.formlyService.fillField(this.lamCustomerCountryField, this.lamCustomerCountriesPromise());
        break;
    }

    if (fillLAMFieldPromise) {
      fillLAMFieldPromise
        .then(() => {
          // for some scenarios LAM field is already filled in at this moment -> trigger change to populate the dependent fields
          this.onLAMChange();
        });
    } else {
      this.onLAMChange();
    }
  };

  private lamCompanyCountriesPromise():Promise<ICompanyCountry[]> {
    return this.companyDataService.getLAMCompanyCountries()
      .then((lamCompanyCountries:ICompanyCountry[]) => {

        // auto-select LAM company country when there is only one
        if (lamCompanyCountries?.length === 1) {
          this.form.patchValue({
            lamCompanyCountry: lamCompanyCountries[ 0 ]
          });
        }

        return lamCompanyCountries;
      });
  }

  private lamCompanyDepartmentsPromise():Promise<ICompanyCountry[]> {
    return this.companyDataService.getLAMCompanyDepartments()
      .then((lamCompanyDepartments:ICompanyCountry[]) => {

        // if the logged in user is an OEM user -> pre-fill with the user's department if filled in. If not filled in then we pre-fill with the department that corresponds with the user's country
        if (this.authService.checkVendorUser()) {
          this.form.patchValue({
            lamCompanyDepartment: this.currentUser.companyDepartment
          });

          if (!this.model.lamCompanyDepartment) {
            return this.companyDataService.getUserCountryDepartment()
              .then((userCountryDepartment:ICompanyCountry) => {
                this.form.patchValue({ lamCompanyDepartment: userCountryDepartment });
                return lamCompanyDepartments;
              });
          }
        }
        // if the logged-in user is a non-OEM user -> auto-select LAM company department when there is only one
        else if (lamCompanyDepartments?.length === 1) {
          this.form.patchValue({
            lamCompanyDepartment: lamCompanyDepartments[ 0 ]
          });
        }

        return lamCompanyDepartments;
      });
  }

  private lamCustomerCountriesPromise():Promise<ICountryExtended[]> {
    return this.companyDataService.getLAMCustomerCountries(this.model.customer?.id)
      .then((customerCountries:ICountryExtended[]) => {

        const customerCountryHeadQuarter:ICountryExtended = _.findWhere(customerCountries, { hasCountryHeadQuarter: true });
        if (customerCountryHeadQuarter) {
          // set to the country of the customer's HQ location
          this.form.patchValue({
            lamCustomerCountry: customerCountryHeadQuarter
          });
        } else if (customerCountries?.length === 1) {
          // auto-select LAM customer country when there is only one
          this.form.patchValue({
            lamCustomerCountry: customerCountries[ 0 ]
          });
        }

        return customerCountries;
      });
  }

  private onLAMChange = ():void => {
    this.webshopService.getLAM()
      .then((lam:ICompanyCountry) => {
        const lamId:number = lam?.id;
        const lamType:string = <string>this.model.lamType?.id;
        this.lamMainContactsField.templateOptions.disabled = !(lamType && lamId);
        this.clearLAMMainContactsField();

        if (lamType && lamId) {
          this.companyDataService.getSuperLAM(lamType, lamId)
            .then((superLAM:IContact) => {
              this.form.patchValue({ superLAM });
              this.setGBDMBasedOnLAM();
            });
        } else {
          this.setGBDMBasedOnLAM();
        }
      });
  };

  // preselect GBDM based on the LAM selection
  private setGBDMBasedOnLAM():void {
    if (!this.isLoggedUserGBDM) {
      if (this.model.lamCompanyCountry) {
        this.form.patchValue({
          gbdm: this.model.lamCompanyCountry?.company?.gbdm // gbdm of BP LAM company country
        });
      } else if (this.model.lamCompanyDepartment) {
        const companyGBDM:IContact = this.model.lamCompanyDepartment?.company?.gbdm;
        this.form.patchValue({
          gbdm: this.model.lamCompanyDepartment.gbdm || companyGBDM // gbdm of OEM LAM company department
        });
      } else if (this.model.lamCustomerCountry) {
        this.webshopService.getLAM()
          .then((lam:ICompanyCountry) => {
            this.form.patchValue({
              gbdm: lam?.company?.gbdm
            });
          });
      }
    }
  }

  // enable/disable LAM type based on the customer company type (enabled only when a customer company is selected)
  public updateLAMCustomerOptionState(customerId:number):void {
    const idxLamTypeCustomer:number = _.findIndex(this.lamTypeField.templateOptions.options, { id: CompanyType.CUSTOMER });
    const lamTypeCustomerDisabled:boolean = !customerId || this.model.customer.companyType !== CompanyType.CUSTOMER;
    this.lamTypeField.templateOptions.options[ idxLamTypeCustomer ].disabled = lamTypeCustomerDisabled;

    if (lamTypeCustomerDisabled) {
      // clearing only lamType is not enough as the field it's not mandatory, therefore we also clear LAM field and their values so the user is forced to reselect it by choosing first a Type
      this.form.patchValue({
        lamType: undefined,
        lamCompanyCountry: undefined,
        lamCompanyDepartment: undefined,
        lamCustomerCountry: undefined,
        superLAM: undefined
      });

      this.clearLAMMainContactsField();
      if (!this.isLoggedUserGBDM) {
        this.form.patchValue({ gbdm: undefined });
      }
    }
  }

  // clear oemMainContacts field while excluding the case when the same selected users are the one in the list of options (eg. when initial page load: options = model)
  private clearOEMMainContactsField():void {
    if (_.isEqual(this.model.oemMainContacts, this.oemMainContactsField.templateOptions.options)) {
      this.form.patchValue({
        oemMainContacts: undefined
      });
    }
  }

  private disableOEMMainContactsField():void {
    this.oemMainContactsField.templateOptions.disabled = !this.model.oem;
  }

  // clear oemMainContacts field while excluding the case when the same selected users are the one in the list of options (eg. when initial page load: options = model)
  private clearLAMMainContactsField():void {
    if (!_.isEqual(this.model.lamMainContacts, this.lamMainContactsField.templateOptions.options)) {
      this.model.lamMainContacts = undefined;
    }
  }

  public ngOnDestroy(): void {
    this.wizard.clearCurrentValidator();
    this.wizard.removeAction(SAVE_ACTION);
  }
}